<div class="m-limit-text">
    <div v-if="!html" ref="originalText" class="m-limit-text__original" v-show="!contentTooTall" aria-hidden="true">
        <slot></slot>
    </div>
    <div v-else v-html="html" ref="originalText" class="m-limit-text__original" v-show="!contentTooTall" aria-hidden="true"></div>
    <div ref="testingText" class="m-limit-text__testing-text" v-show="!hasFinish" aria-hidden="true"></div>
    <m-dynamic-template class="m-limit-text__content" @updated="onUpdatedOpen($event)" :template="getReduceText" v-if="!internalOpen" v-show="contentTooTall"></m-dynamic-template>
    <m-dynamic-template class="m-limit-text__content" @updated="onUpdatedClose($event)" :template="getFullText" v-if="internalOpen" v-show="contentTooTall"></m-dynamic-template>
</div>
